/**
 * Helper class used to generate session unique ID
 */
var UniqueIdGenerator = /** @class */ (function () {
    function UniqueIdGenerator() {
    }
    Object.defineProperty(UniqueIdGenerator, "UniqueId", {
        /**
         * Gets an unique (relatively to the current scene) Id
         */
        get: function () {
            var result = this._UniqueIdCounter;
            this._UniqueIdCounter++;
            return result;
        },
        enumerable: false,
        configurable: true
    });
    // Statics
    UniqueIdGenerator._UniqueIdCounter = 1;
    return UniqueIdGenerator;
}());
export { UniqueIdGenerator };
//# sourceMappingURL=uniqueIdGenerator.js.map